// extracted by mini-css-extract-plugin
export default {"AdminInput":"styles_AdminInput__yCxve","input":"styles_input__FzA56","danger":"styles_danger__db+Jj"};